import { useMemo } from 'react';

import { DEFAULT_SHIPPING_METHOD_NAME } from 'corporate/constants';
import { useGetShippingMethods } from 'corporate/hooks';
import { QuoteEntityType } from 'quotes/enums';

import { getAlternateDefaultValues } from './utils';

interface IProps {
  entityType: QuoteEntityType;
  isAlternateVersionEnabled: boolean;
}

// The default shipping method belongs in the defaults object: ShippingMethodFormField's own
// one-shot setValue is not dirty, so any later reset to defaults that lack it wipes it for good.
export const useAlternateDefaultValues = ({ entityType, isAlternateVersionEnabled }: IProps) => {
  const isAlternateOrder = isAlternateVersionEnabled && QuoteEntityType.ORDER === entityType;

  // Same query key as ShippingMethodFormField, so no extra request.
  const { records: shippingMethods } = useGetShippingMethods(
    { filters: { name: DEFAULT_SHIPPING_METHOD_NAME } },
    isAlternateOrder
  );

  const defaultShippingMethod =
    shippingMethods.find((method) => method.name === DEFAULT_SHIPPING_METHOD_NAME) ?? null;

  return useMemo(
    () =>
      getAlternateDefaultValues({ entityType, isAlternateVersionEnabled, defaultShippingMethod }),
    [entityType, isAlternateVersionEnabled, defaultShippingMethod]
  );
};
